// export const formatFileName = (rawName) => {
//     if (!rawName || typeof rawName !== 'string') return '';
  
//     const nameWithoutExt = rawName.replace('.pdf', '');
//     const parts = nameWithoutExt.split('-');
  
//     // Remove leading numeric/infocode chunks like "0516", "ok24", etc.
//     const contentStartIndex = parts.findIndex(part => !/^\d+$/.test(part) && !/^ok\d*$/.test(part));
//     const meaningfulParts = parts.slice(contentStartIndex);
  
//     const cleanName = meaningfulParts.join(' ');
  
//     return cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
//   };

export const formatFileName = (rawName) => {
    if (!rawName || typeof rawName !== 'string') return '';
  
    const nameWithoutExt = rawName.replace('.pdf', '');
    const parts = nameWithoutExt.split('-');
  
    // Known starting words we want to detect as the beginning of real content
    const meaningfulWords = ['aftale', 'overenskomst', 'tillæg', 'protokollat', 'vedrørende', 'notat'];
  
    // Find the index of the first word that looks like actual content
    const contentStartIndex = parts.findIndex(part =>
      meaningfulWords.includes(part.toLowerCase())
    );
  
    // Fallback: skip all numeric or "ok*" parts if no known word is found
    const startIndex = contentStartIndex >= 0
      ? contentStartIndex
      : parts.findIndex(part => !/^\d+$/.test(part) && !/^ok\d*$/.test(part) && part.toLowerCase() !== 'og');
  
    const meaningfulParts = parts.slice(startIndex);
    const cleanName = meaningfulParts.join(' ');
  
    return cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
  };
  